<template>
  <div class="Footer">
    <div class="content">
      <div class="one">
        <div style="display: flex;">
          <div class="footerImg">
            <p style="margin-top: 33px;">
              <i>LOADING MY TAG</i>
            </p>
            <p>
              <i>BROADEN YOUR VISION</i>
            </p>
            <img class="footerL" src="../assets/img/footerL.png" alt />
            <img class="footerText" src="../assets/img/footerText.png" alt />
          </div>
          <ul class="about">
            <li>
              <router-link to="Case">行业/案例</router-link>
            </li>
            <li>
              <router-link to="Product">产品</router-link>
            </li>
            <li>
              <router-link to="Customized">服务/定制</router-link>
            </li>
            <li>
              <router-link to="Journalism">新闻</router-link>
            </li>
            <li>
              <router-link to="AboutUs">关于我们</router-link>
            </li>
          </ul>
        </div>
        
        <ul class="telephone">
          <li style="color: #007BFF;">联系热线</li>
          <li style="margin-top: 6px;" v-for="(item, index) in detail.lxphone" :key="index">{{item}}</li>
          <li style="margin-top: 14px; color: #007BFF;">邮箱</li>
          <li style="margin-top: 6px;">{{detail.lxmail}}</li>
          <li style="margin-top: 6px;">{{detail.qtmail}}</li>
          <!-- <li style="margin-top: 23px;">关于我们</li> -->
          <li
            style="margin-top: 24px; border: none; font-size:18px; color: #007BFF; font-weight:500; cursor:pointer;"
          >
            <img
              src="../assets/img/jiaru.png"
              alt
              style="display: inline-block; width: 26px; height: 17px;margin-right: 6px;"
            />
            <a :href="detail.zpurl" style="color: #007BFF;">加入我们</a>
          </li>
        </ul>
      </div>
      <p
        style="text-align: center; border: none; font-size:10px; color: #ffffff; font-size: 13px;"
      >Copyright 2013-{{ detail.endYear }}<br>http://www.line-found.com/ Built By 无锡朗帆信息科技有限公司</p>
    </div>
    <div class="two">
      <div class="content">
        苏ICP备
        <img src="../assets/img/guohui.png" alt style="width: 18px; height: 12px;" />
        苏公网安备 32021402001060号
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String
  },
  data() {
    return {
      detail: {}
    }
  },
  created() {
    this.getAboutDetail();
  },
  methods: {
    getAboutDetail() {
      this.fetchGet("index/aboutUs")
        .then(res => {
          res.data.lxphone = res.data.lxphone.split('|')
          this.detail = res.data
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  mounted() {}
};
</script>
<style scoped lang="less">
.Footer {
  // position: fixed;
  // bottom: 0;
  // left: 0;
  width: 100%;
  height: 380px;
  background-color: #2d3845;
  .two {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #202d3b;
    font-size: 12px;
    margin-top: 20px;
  }
  .content {
    width: 1280px;
    margin: 0 auto;
    color: #ffffff;
    .footerImg {
      width: 375px;
      position: relative;
      p {
        font-size: 16px;
      }
      .footerL {
        width: 172px;
        height: 256px;
        position: absolute;
        left: 0;
        top: 0;
      }
      .footerText {
        width: 300px;
        height: auto;
        position: absolute;
        left: 0;
        top: 90px;
      }
    }
    .one {
      height: 320px;
      width: 100%;
      // padding-top: 33px;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      .about {
        margin-left: 116px;
        width: 160px;
        margin-top: 40px;
        a {
          color: #ffffff;
        }
        li {
          height: 38px;
          line-height: 38px;
          border-top: 1px solid #555555;
          font-size: 13px;
          font-weight: 400;
        }
      }
      .telephone {
        margin-top: 41px;
        font-size: 15px;
        text-align: right;
      }
    }
  }
}
</style>
